if (!customElements.get('instagram-video')) {
  class InstagramVideo extends HTMLElement {
    constructor() {
      super();
      this.handlePlayClick = this.handlePlayClick.bind(this);
    }

    connectedCallback() {
      this.init();
    }

    disconnectedCallback() {
      this.cleanup();
    }

    init() {
      this.openInPopup = this.dataset.openInPopup === 'true';
      this.playBtn = this.querySelector('[data-play]');
      this.videoContainer = this.querySelector('[data-video-container]');
      this.closeButtonTemplate = this.querySelector('[data-popup-close-button]')?.content;

      if (this.playBtn && this.videoContainer) {
        this.playBtn.addEventListener('click', this.handlePlayClick);
      }
    }

    cleanup() {
      if (this.playBtn) {
        this.playBtn.removeEventListener('click', this.handlePlayClick);
      }
    }

    handlePlayClick() {
      if (!this.videoContainer) return;

      const video = this.videoContainer.querySelector('video');
      if (!video) return;

      if (this.openInPopup) {
        this.openPopup(video);
      } else {
        this.playInline(video);
      }
    }

    playInline(video) {
      video.muted = false;
      video.controls = true;
      video.play().catch(() => {});
      this.playBtn.classList.add('hidden');
    }

    openPopup(video) {
      this.activeVideo = video;
      this.originalVideoParent = video.parentNode;
      this.originalVideoState = {
        muted: video.muted,
        controls: video.controls,
      };
      this.videoPlaceholder = document.createElement('div');
      this.videoPlaceholder.className = 'instagram-video__placeholder';
      this.videoPlaceholder.style.display = 'block';
      this.videoPlaceholder.style.width = '100%';
      const measuredHeight = video.getBoundingClientRect().height || this.videoContainer.offsetHeight || 1;
      this.videoPlaceholder.style.height = `${Math.round(measuredHeight)}px`;
      this.originalVideoParent.insertBefore(this.videoPlaceholder, video);

      this.fixedWrapper = document.createElement('div');
      this.fixedWrapper.className = 'fixed-video-wrapper';
      this.fixedWrapper.appendChild(video);

      if (this.closeButtonTemplate?.firstElementChild) {
        this.closeButton = this.closeButtonTemplate.firstElementChild.cloneNode(true);
        this.fixedWrapper.appendChild(this.closeButton);
        this.closeButton.addEventListener('click', this.handleCloseClick);
      }

      document.body.appendChild(this.fixedWrapper);

      video.muted = false;
      video.controls = true;
      video.play().catch(() => {
        this.playBtn.classList.remove('hidden');
      });

      this.playBtn.classList.add('hidden');
    }

    handleCloseClick = () => {
      if (this.activeVideo) {
        this.activeVideo.pause();
      }

      if (this.originalVideoParent && this.activeVideo) {
        if (this.videoPlaceholder?.parentNode) {
          this.originalVideoParent.replaceChild(this.activeVideo, this.videoPlaceholder);
        } else {
          this.originalVideoParent.appendChild(this.activeVideo);
        }
        this.activeVideo.muted = this.originalVideoState?.muted ?? true;
        this.activeVideo.controls = this.originalVideoState?.controls ?? false;
      }

      this.videoPlaceholder?.remove();
      this.videoPlaceholder = null;
      this.originalVideoParent = null;
      this.activeVideo = null;
      this.originalVideoState = null;

      if (this.fixedWrapper) {
        if (this.closeButton) {
          this.closeButton.removeEventListener('click', this.handleCloseClick);
          this.closeButton = null;
        }
        this.fixedWrapper.remove();
        this.fixedWrapper = null;
      }

      this.playBtn.classList.remove('hidden');
    };
  }

  customElements.define('instagram-video', InstagramVideo);
}
